import Swiper from 'swiper';

function sliderRelatedPosts() {
  new Swiper('.swiper-related-posts', {
    grabCursor: true,
    spaceBetween: 8,
    slidesPerView: 1.5,
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      1110: {
        slidesPerView: 3,
        spaceBetween: 34,
      }
    }
  });
}
sliderRelatedPosts();